<template><!--<template v-if >-->
	<div v-if="Pagos && pago" id="reporte" class="table-responsive-lg">
		<table id="encabezado">
			<tr>
				<td style="width: 20%"><img alt="logo" style="height: 200px; width: 200px" src="..\..\..\assets\Logotipo_Positivo_Vertical-recibo.png"></td>
				<td class="text-center"><h2>PODER JUDICIAL DEL ESTADO DE AGUASCALIENTES<br>
				REPORTE DE PAGOS</h2><br>
				<h3>{{(Activo) ? "Pagos Realizados en Caja" : "Folios Cancelados"}}</h3><br>
				<h3>{{(TipoReporte == 2 && Pagos[0]) ? 'Tipo De Rubro: ' + Pagos[0].RubroDBPJ.Nombre.toUpperCase() : 
					  (TipoReporte == 3 && Pagos[0]) ? 'Juzgado: ' + Pagos[0].Expediente.Area.Nombre : ""}}</h3><br>
			{{(fechas.fechaInicio != null && fechas.fechaFin != null) ? "DEL " + FechaDDMMAAAA(fechas.fechaInicio) + " AL " + FechaDDMMAAAA(fechas.fechaFin) : "HISTORICO"}}</td>
		</tr>
	</table>
	<table class="table" id="resultados">
		<tr>
			<th>FOLIO</th>
			<th>FECHA</th>
			<th v-if="TipoReporte!=3">JUZGADO</th>
			<th>DOC. REFERENCIA</th>
			<th>NOMBRE</th>
			<th v-if="TipoReporte!=2">CONCEPTO</th>
			<th v-if="!Activo">MOTIVO DE CANCELACION</th>
			<th>CANTIDAD</th>
		</tr>
		<template>
			<tr v-for="(pago, indexP) in Pagos" :key="indexP">
				<td>{{pago.Folio}}</td>
				<td>{{FechaDDMMAAAA(pago.FechaDePago)}}</td>
				<td v-if="TipoReporte!=3">{{pago.Expediente.Area.Abreviatura}}</td>
				<td>{{((pago.Expediente.TipoDocumento.TipoDocumentoId) == 23) ? "CD " : //modificar en caso de mas tipo doc
					  ((pago.Expediente.TipoDocumento.TipoDocumentoId) == 26) ? "CE " : "EXP "}}{{(pago.Expediente.NumeroRomano == null) ? pago.Expediente.Consecutivo : pago.Expediente.Consecutivo +"-"+ pago.Expediente.NumeroRomano}}</td>
			<td>{{pago.Nombre + ' ' +  ((pago.ApellidoPaterno != null) ? pago.ApellidoPaterno : '') + ' ' + ((pago.ApellidoMaterno != null) ?  pago.ApellidoMaterno : '')}}</td>
			<td v-if="TipoReporte!=2">{{pago.RubroDBPJ.Nombre.toUpperCase()}}</td>
			<td v-if="!Activo">{{pago.Observaciones}}</td>
			<td>{{(Excel ? pago.Monto : '$' + agregarCeros(pago.Monto))}}</td>
		</tr>
		</template>
	
	<tr><td colspan="6">{{""}}</td></tr>
	<tr v-if="Activo"><td>{{"TOTAL "}}</td><td v-if="TipoReporte==2 || TipoReporte==3" colspan="4">{{""}}</td><td v-else colspan="5">{{""}}</td><td>{{Excel ? total : '$'+ agregarCeros(total)}}</td></tr>
</table>

<div style="height: 5px; width: 100%">
</div>

<div v-if="grafica()" style="display: flex; justify-content: center; height: 700px;">
<img style="margin-bottom : auto; max-height: 100%; max-width: 100%;" :src="grafica()"/>
</div>

</div>
<div v-else-if="Devoluciones && devolucion" id="reporte" class="table-responsive-lg">
	<table id="encabezado">
			<tr>
				<td style="width: 20%"><img alt="logo" style="height: 200px; width: 200px" src="..\..\..\assets\Logotipo_Positivo_Vertical-recibo.png"></td>
				<td class="text-center"><h2>PODER JUDICIAL DEL ESTADO DE AGUASCALIENTES<br>
				REPORTE DE DEVOLUCIONES</h2><br>
				<h3>{{"Devoluciones Realizadas"}}</h3><br>
				<h3>{{(TipoReporte == 2 && Devoluciones[0]) ? 'Tipo De Rubro: ' + Devoluciones[0].Rubro.RubroDBPJ.Nombre.toUpperCase() : 
					  (TipoReporte == 3 && Devoluciones[0]) ? 'Juzgado: ' + Devoluciones[0].Expediente.Area.Nombre : ""}}</h3><br>
			{{(fechas.fechaInicio != null && fechas.fechaFin != null) ? "DEL " + FechaDDMMAAAA(fechas.fechaInicio) + " AL " + FechaDDMMAAAA(fechas.fechaFin) : "HISTORICO"}}</td>
		</tr>
	</table>

	<table class="table" id="resultados">
		<tr>
			<th>FOLIO</th>
			<th style="width: 5%">FECHA DE ENTREGA DEVOLUCION</th>
			<th>DOC. REFERENCIA</th>
			<th>A NOMBRE DE</th>
			<th style="width: 5%">NO DE CHEQUE</th>
			<th v-if="TipoReporte!=2">CONCEPTO</th>
			<th style="width: 5%">DEVUELTO A</th>
			<th style="text-align: right; width: 5%">CANTIDAD DEVUELTA</th>
		</tr>
		<template >
			<tr  v-for="(devolucion, indexDev) in Devoluciones" :key="indexDev">
				<td>{{devolucion.Rubro.Folio}}</td>
				<td>{{FechaDDMMAAAA(devolucion.FechadeEntregaDevolucion)}}</td>
				<td>{{((devolucion.Expediente.TipoDocumento.TipoDocumentoId) == 23) ? "CD " : //modificar en caso de mas tipo doc
					  ((devolucion.Expediente.TipoDocumento.TipoDocumentoId) == 26) ? "CE " : "EXP "}}{{(devolucion.Expediente.NumeroRomano == null) ? devolucion.Expediente.Consecutivo : devolucion.Expediente.Consecutivo +"-"+ devolucion.Expediente.NumeroRomano}}</td>
				<td>{{devolucion.Persona.Nombre + ' ' +  ((devolucion.Persona.ApellidoPaterno != null) ? devolucion.Persona.ApellidoPaterno : '') + ' ' + ((devolucion.Persona.ApellidoMaterno != null) ?  devolucion.Persona.ApellidoMaterno : '')}}</td>
				<td>{{devolucion.NumeroCheque}}</td>
				<td v-if="TipoReporte!=2">{{devolucion.Rubro.RubroDBPJ.Nombre}}</td>
				<td>{{devolucion.TipoEstatusDevolucion.Nombre}}</td>
				<td style="text-align: right">{{'$'+agregarCeros(devolucion.MontoDevolucion)}}</td>
			</tr>
		</template>
	<tr><td colspan="8">{{""}}</td></tr>
	<template>
		<tr v-for="(tiposDev, indexT) in tipoEstatusDevoluciones" :key="indexT">
			<td colspan="4">{{'TOTAL ' + tiposDev.nombre.toUpperCase()}}</td>
			<td colspan="4" style="text-align: right"><b>{{'$'+agregarCeros(tiposDev.montoDev)}}</b></td>
		</tr>
		<tr>
			<td colspan="4">{{'TOTAL FINAL ' }}</td><td colspan="4" style="text-align: right"><b>{{'$' + agregarCeros(totalFinalDev)}}</b></td>
		</tr>
	</template>
	</table>

</div>
</template>

<script>
	import Vue from 'vue'
	import VueHtmlToPaper from 'vue-html-to-paper'
	import api from '@/../static/js/api'
	import axios from 'axios'
	import comun from "@/../static/js/comun"
	import enumeraciones from '@/../static/js/enumeraciones'
	import func from '../Comun/Funciones/comun.js'

	import * as XLSX from 'xlsx/xlsx.mjs'


	Vue.use(VueHtmlToPaper)

	export default{
		data(){
			return{
				fechas:{
					fechaInicio: String,
					fechaFin: String
				},
				Pagos: [],
				Activo: Boolean,
				Excel: false,
				Devoluciones : [],
				pago: false,
				devolucion: false,
				tipoEstatusDevoluciones: null
			}
		},
	computed: {

		total(){//ir sumando cada monto
			
				if(this.Pagos){
				var total = 0;

				this.Pagos.forEach((pago)=>{
					total += pago.Monto
				});
				return total;
			}
			
		},
		totalFinalDev(){
			if(this.Devoluciones){
				var totalFinalDev = 0;

				this.Devoluciones.forEach((Devolucion)=>{
					totalFinalDev += Devolucion.MontoDevolucion
				});
				return totalFinalDev;
			}
		}
	},
	watch:{

	},
	methods:{

		buscarPagosFechas: function(parametros){
			this.fechas.fechaInicio = parametros.fechaInicio;
			this.fechas.fechaFin = parametros.fechaFin;

			const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

			return axios.post(api.conexion + api.SIVAC.sistema.reportes.pagos.ReporteCaja, parametros, headerPeticion)
			.then( respuesta => {
				comun.SeEstaCargandoInformacion(false);
				if (respuesta.data.SiHayError) {
					this.Pagos.length = 0;
					comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
					throw new Error("No hay");
				}
				else{  
					this.pago = true;
					this.Pagos = respuesta.data.Pagos
					return this.Pagos         
					}
				}).catch(error => {
					return error;
				})
		},

		buscarDevolucionesFechas: function(parametros){
			this.fechas.fechaInicio = parametros.fechaInicio;
			this.fechas.fechaFin = parametros.fechaFin;
			this.Pagos.length = 0;

			const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false); 

			return axios.post(api.conexion + api.SIVAC.sistema.reportes.pagos.ReporteDevoluciones, parametros, headerPeticion)
			.then( respuesta => {
				comun.SeEstaCargandoInformacion(false);
				if (respuesta.data.SiHayError) {
					console.log(respuesta)
					comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
					throw new Error("No hay");
				}
				else{  
					this.Devoluciones = respuesta.data.Devoluciones; 
					this.devolucion = true;
					this.tipoEstatusDevoluciones = this.getTiposEstatusDevoluciones(this.Devoluciones); 

					
					return this.Devoluciones    
					}
				}).catch(error => {
					return error;
				})
		},

		async imprimirReporte(parametros){///para imprimir 	
			const buscar = await this.buscarPagosFechas(parametros);
			this.Activo = parametros.activo;

			if(this.Pagos.length==0 )this.$parent.actualizarGrafica()

			if(!buscar.message){
				setTimeout(() => {
					this.$htmlToPaper('reporte', {
						name: '_blank',
						styles: [
						'../../../../static/css/bootstrap@4.0.0.min.css'
						],

					}, ()=>{
						console.log('Cerrado');
						this.pago = false;
						if(this.Pagos)this.$parent.actualizarGrafica()
					});
				}, 1);
			}
		},

		async imprimirReporteDevoluciones(parametros){
			const buscar = await this.buscarDevolucionesFechas(parametros);
			this.Activo = parametros.activo;

			if(this.Devoluciones.length==0 )this.$parent.actualizarGrafica()

			if(!buscar.message){
				setTimeout(() => {
					this.$htmlToPaper('reporte', {
						name: '_blank',
						styles: [
						'../../../../static/css/bootstrap@4.0.0.min.css'
						],

					}, ()=>{
						console.log('Cerrado');
						this.devolucion = false; 
						if(this.Devoluciones)this.$parent.actualizarGrafica()
					});
				}, 1);
			}

		},

		async crearExcel(parametros){///para descragar en excel
			this.Excel = true;
			const buscar = await this.buscarPagosFechas(parametros);
			this.Activo = parametros.activo;

			if(!buscar.message){
				setTimeout(()=>{
					var tabla = document.getElementById("resultados")
					
					var libro = XLSX.utils.table_to_book(tabla, {raw : true})

					var titulo = ((this.TipoReporte == 2 ? this.Pagos[0].RubroDBPJ.Nombre.toUpperCase() : 
								   this.TipoReporte == 3 ? this.Pagos[0].Expediente.Area.Abreviatura : 
								   "GENERAL") + 
								   " Pagos del " + this.FechaExcel(parametros.fechaInicio) +" al "+ this.FechaExcel(parametros.fechaFin))
					
					var rango = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);
					var cantidadCelda = ''

					Object.keys(libro.Sheets).forEach((sheet) =>{
						Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
						if(libro.Sheets[sheet][celda].v === 'CANTIDAD'){//debe coincidir con el de arriba
							cantidadCelda = celda.replace(/[^A-Za-z]/g, '');//quita numeros
						}

						for(var R = 1; R <= rango.e.r; ++R){
							if(libro.Sheets.Sheet1[cantidadCelda + (R+1)]) {
								libro.Sheets.Sheet1[cantidadCelda + (R+1)].v = Number(libro.Sheets.Sheet1[cantidadCelda + (R+1)].v)
								libro.Sheets.Sheet1[cantidadCelda + (R+1)].t = 'n'
								libro.Sheets.Sheet1[cantidadCelda + (R+1)].z = "$#,##0.00;(#,##0.00)"
							}
						}

						})
					});
					XLSX.writeFile(libro, titulo + ".xlsx")
					this.Excel = false;
				}, 1)
			}
		},

		getTiposEstatusDevoluciones : function(tipoEstatusDevoluciones){
			var tipos = [] ;
			tipoEstatusDevoluciones.forEach((devolucion) => {
				if(!tipos.find(item => item.id == devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId)){
					var objeto = {
						id : devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId, 
						nombre : devolucion.TipoEstatusDevolucion.Nombre,
						montoDev: devolucion.MontoDevolucion
					};
					tipos.push(objeto)
				}
				else{
					var posicion = tipos.findIndex(item => item.id == devolucion.TipoEstatusDevolucion.TipoEstatusDevolucionId);
					tipos[posicion].montoDev += devolucion.MontoDevolucion
				}
			});
			return tipos;
		},

		FechaDDMMAAAA : function(fecha){
			return func.FechaDDMMAAAA(fecha)
		},

		FechaExcel : function(fecha){
			return func.FechaExcel(fecha)
		},

		agregarCeros : function(monto){
			return func.agregarCeros(monto)
		}
	},
	props:{
		TipoReporte : 0,
		grafica : null
	}
}

</script>

<style>
.bloquearDiv{
	pointer-events: none;
}
.wrapDivBloqueado
{
	opacity: 0.7;
	cursor: not-allowed;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Reportes/ReporteArchivo.vue